import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const image41MmaWideRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  aspectRatio: 4,
  type: 'Image4x1',
  associationType: 'ImageMedia4x1',
  imagePreviewHeight: 152,
  isRequired: false,
  minimumRequirements: 0,
  minSize: [608, 152],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Wide Image Multimedia Ad'),
    stringKey: _TL_('4 : 1'),
  },
  previewSettings: {
    showAdsLabel: true,
    showImage: true,
    showDescription: true,
    showShortHeadline: true,
    showAdditionalDisclaimer: true,
    showAction: true,
    showUrl: true,
    showImageGradient: true,
  },
  styleOverrides: {
    adsLabel: {
      right: '0%',
      backgroundColor: 'white',
    },
    description: {
      color: 'white',
      bottom: 5,
      position: 'relative',
      fontSize: 14,
    },
    imageGradient: {
      backgroundImage: 'linear-gradient(to left, transparent 0, black 100%)',
      width: '100%',
      height: 152,
      display: 'block',
      position: 'absolute',
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
      borderRadius: 0,
      boxShadow: 'none',
    },
    shortHeadline: {
      fontSize: 24,
      lineHeight: '16px',
      position: 'relative',
      color: 'white',
      paddingBottom: 5,
      fontWeight: 200,
      bottom: 15,
    },
    textContainer: {
      position: 'absolute',
      color: '#bebebe',
      bottom: 25,
      left: 0,
      fontSize: 10,
      lineHeight: '16px',
      paddingLeft: 32,
    },
    finalUrl: {
      color: 'white',
      bottom: 10,
      position: 'relative',
      fontSize: 10,
    },
    actionButton: {
      color: '#666',
      opacity: '70%',
      padding: '7px 16px 8px 16px',
      position: 'relative',
      backgroundColor: '#EEE',
    },
  },
};

export default image41MmaWideRaw;
